<div class="col-12 chart-container mt-3">
  <h4>System Usage</h4>
  @if (chart.data) {
    <highcharts-chart
      class="col-12 pull-left"
      [Highcharts]="Highcharts"
      [options]="chart.data"
    />
  }
</div>

<ngx-loading
  [show]="loading"
  [config]="{
    fullScreenBackdrop: false,
  }"
/>
